// @flow

import React from 'react';
import SearchContext from '../../utils/searchContext';
import SearchableTextInput from '../../common/SearchableTextInput';
import SelectVocabularyValue from '../../common/SelectVocabularyValue';

const SearchFiltersContainer = () => {
  return (
    <SearchContext.Consumer>
      {({ setFilters, translations, vocabulary }) => {
        return (
          <div className="form-search-wrapper">
            <form>
              <div className="label">
                {translations && translations.search_results_filters_label
                  ? translations.search_results_filters_label
                  : 'Filter results'}
              </div>

              <div className="search-course-input">
                <SearchableTextInput
                  onUpdateValue={setFilters}
                  translations={translations}
                />
              </div>
              <SelectVocabularyValue
                id="phd_type"
                onUpdateSelect={(value) => setFilters({ phd_type: value })}
                emptyValueLabel={translations.phd_type_label}
                vocabulary={vocabulary.PhDTypesCatalog}
              />
              <SelectVocabularyValue
                id="department"
                onUpdateSelect={(value) => setFilters({ department: value })}
                emptyValueLabel={translations.department_label}
                vocabulary={vocabulary.DepartmentsCatalog}
              />
              <SelectVocabularyValue
                id="educational_activity"
                onUpdateSelect={(value) =>
                  setFilters({ educational_activity: value })
                }
                emptyValueLabel={translations.educational_activity_label}
                vocabulary={vocabulary.EducationalActivitiesCatalog}
              />
            </form>
          </div>
        );
      }}
    </SearchContext.Consumer>
  );
};

export default SearchFiltersContainer;
